import axios, { InternalAxiosRequestConfig } from 'axios';
import * as Sentry from '@sentry/react';
import Cookies from 'js-cookie';
import { AUTH_COOKIE, REFRESH_COOKIE } from '../constants';

export const axiosClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

const createConfigUrl = (
  config: InternalAxiosRequestConfig,
  accessToken: string | undefined
) => {
  
  let configNew = config;
  const hasTokenUrl = config.url?.includes(import.meta.env.VITE_API_TOKEN_URL) || false;
  const hasResetUrl = config.url?.includes(import.meta.env.VITE_API_RESET_PASSWORD_URL) || false;
  if (config?.url && !hasTokenUrl  && !hasResetUrl) {
    configNew = {
      ...config,
      url: `${config.url}${
        config.url?.includes('?') ? '&' : '?'
      }access_token=${accessToken}`,
    };
  }

  return configNew;
};

axiosClient.interceptors.request.use(
  (config) => {
    const accessToken = Cookies.get(AUTH_COOKIE);

    return createConfigUrl(config, accessToken);
  },
  (error) => {
    return Promise.reject(error);
  }
);

const refreshParams = {
  client_id: 'api',
  grant_type: 'refresh_token',
  refresh_token: '',
};

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = Cookies.get(REFRESH_COOKIE);

        const response = await axios.post(
          `${import.meta.env.VITE_API_TOKEN_URL}`,
          null,
          { params: { ...refreshParams, refresh_token: refreshToken } }
        );

        const { access_token, refresh_token, expires_in } = response.data;

        // Secure cookies are dropped on plain-http origins other than localhost
        const isSecure = window.location.protocol === 'https:';

        Cookies.set(AUTH_COOKIE, access_token, {
          expires: expires_in,
          secure: isSecure,
          sameSite: 'Strict',
        });

        Cookies.set(REFRESH_COOKIE, refresh_token, {
          expires: expires_in,
          secure: isSecure,
          sameSite: 'Strict',
        });
        originalRequest.headers['Authorization'] = `Bearer ${access_token}`;

        return axiosClient(originalRequest);
      } catch (refreshError) {
        Sentry.captureException(refreshError);
        Cookies.remove(AUTH_COOKIE);
        Cookies.remove(REFRESH_COOKIE);

        // window.location.href = '/login';
      }

      return Promise.reject(error);
    }
  }
);
